import React from "react"
import { ThemeProvider, createTheme } from "@mui/material"

const Theme = (props:any) => {
    const theme = createTheme({
        palette:{
            primary:{
                main: '#cfa04f',
                light: '#e4cca2',
                dark: '#a97925',
                contrastText: '#fff',
                // '50': 'rgba(228, 204, 162, 0.5)'
            },
            secondary:{
                main:'#333E48',
                light:'#515d68',
                dark:'#17232f',
                contrastText:'#fff',
            }
        }
    })

    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
}

export default Theme